module.exports = __webpack_public_path__ + "img/signature_background_desktop@2x.7c1efec.webp";